const ONE_MONTH_MS = 30 * 24 * 60 * 60 * 1000;

export function getUpcomingExpiry(value, now = new Date()) {
  if (!value) return null;
  const expiry = new Date(value);
  const remaining = expiry.getTime() - now.getTime();
  if (Number.isNaN(remaining) || remaining <= 0 || remaining > ONE_MONTH_MS) {
    return null;
  }
  return expiry;
}